// Structured data schema generators for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Horwath HTL",
  "url": "https://htlmarketcompass.com",
  "logo": "https://htlmarketcompass.com/favicon.png",
  "description": "Leading hospitality consulting firm providing market intelligence and strategic insights for the global hotel and tourism industry",
  "sameAs": [
    "https://www.linkedin.com/company/horwath-htl",
    "https://twitter.com/HorwathHTL"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "sales",
    "email": "info@horwathhtl.com"
  }
};

export const generateProductSchema = (
  marketName: string,
  description: string,
  price: string | number,
  imageUrl?: string
) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": `${marketName} Hotel Market Report`,
  "description": description,
  "image": imageUrl || "https://htlmarketcompass.com/images/default-report.jpg",
  "brand": {
    "@type": "Brand",
    "name": "Horwath HTL"
  },
  "offers": {
    "@type": "Offer",
    "price": price,
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock",
    "priceValidUntil": new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    "seller": {
      "@type": "Organization",
      "name": "Horwath HTL"
    }
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "127",
    "bestRating": "5",
    "worstRating": "1"
  }
});

export const generateBreadcrumbSchema = (
  items: Array<{ name: string; url: string }>
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url.startsWith('http') ? item.url : `https://htlmarketcompass.com${item.url}`
  }))
});

export const generateLocalBusinessSchema = (
  marketName: string,
  description: string
) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Market Intelligence Report",
  "name": `${marketName} Hospitality Market Analysis`,
  "description": description,
  "provider": {
    "@type": "Organization",
    "name": "Horwath HTL",
    "url": "https://htlmarketcompass.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": marketName
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Market Reports",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Quarterly Market Report",
          "description": "Comprehensive quarterly analysis of hotel market performance"
        }
      },
      {
        "@type": "Offer", 
        "itemOffered": {
          "@type": "Service",
          "name": "Annual Subscription",
          "description": "Full year access to all market reports and updates"
        }
      }
    ]
  }
});

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "HTL MarketCompass",
  "url": "https://htlmarketcompass.com",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://htlmarketcompass.com/global-market-reports?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export const generateFAQSchema = (
  faqs: Array<{ question: string; answer: string }>
) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});